import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useLocation, useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { notificationFilterById } from "../../../../../actions/Utilities/NotificationFilter";
import MaterialTableTS from "../../../../../components/tables/MaterialTableTS";
import { toast } from "../../../../../components/toastNotification";
import { permissionsSelector } from "../../../../Login/selectors/permissionSelector";
import useGetAutopay from "../hook/useGetAutopay";
import TableFilters from "components/TableFilters";
import AddButton from "../../../../../components/AddButton";
import EditButton from "../../../../../components/EditButton";
import SaveButton from "../../../../../components/SaveButton";
import CancelButton from "../../../../../components/CancelButton";
import { PERMISSIONS } from "../../../../PermissionsConstants";
import AutopayForm from "../form/autoPayForm";
import useEditAutopay from "../hook/useEditAutopay";
import TextInput from "../../../../../components/TextInput";
import { deactivateAutopay } from "../../../../../actions/Utilities/VendorConfiguration";
import { IVendorConfigurationRepository } from "../type";
import {
  addAutopay,
  selectedRowsAutopay,
  rowForAutopay,
  editAutopayName,
  editRowAutopay,
  autoPayFilterText,
} from "../atoms/atoms";
import ConfirmBoxModal from "../../../../../components/ConfirmBoxModal";
import ConfirmBoxDelete from "../../../../../components/ConfirmBoxDelete";

const AutopayTable: React.FC = () => {
  const userPermissions = useRecoilValue(permissionsSelector);
  const addPermission = PERMISSIONS.permission_utilities_autopay_add;
  const deletePermission =
    PERMISSIONS.permission_utilities_autopay_delete;
  const editPermission = PERMISSIONS.permission_utilities_autopay_edit;
  const [accountList, setAccountList] = useState([]);
  const [accountFilteredData, setAccountFilteredData] = useState([]);

  const [isSaving, setIsSaving] = useState(false);
  const [dataIsChanged, setDataIsChanged] = useState(false);
  const [edit, setEdit] = useState(false);
  const [actionEditState, setActionEditState] = useRecoilState(
    editAutopayName
  );
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsAutopay
  );
  const [editRowId, setEditRowId] = useRecoilState(editRowAutopay);
  const [rowToEdit, setRowToEdit] = useRecoilState(rowForAutopay);
  const [hideColumn, sethideColumn] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [newData, setNewData] = useState<IVendorConfigurationRepository>();
  const [hasAutopay, setHasAutopay] = useState(true);
  const [filterText, setFilterText] = useState("");
  const [actionAddState, setActionAddState] = useRecoilState(addAutopay);
  const queryClient = useQueryClient();
  const [rowsCount, setRowsCount] = useState(0);
  const [filterTextState, setFilterTextState] = useRecoilState(
    autoPayFilterText
  );
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const {
    data: accountData,
    isLoading: isFetching,
    isSuccess: accountSuccess,
  } = useGetAutopay();

  useEffect(() => {
    if (accountSuccess && accountData) {
      if (accountData?.status === 200) {
        setAccountList(accountData?.data.map((data) => ({ ...data })));
      } else {
        toast.fire(
          "Server Error",
          "Cannot retrieve Autopay Data",
          "error"
        );
      }
    } else {
      setAccountList([]);
    }
  }, [accountData, accountSuccess]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent;

  if (location.state == null) {
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setAccountFilteredData(result);
          setAccountId(recordIdFromRecent.recordId);
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [history, recordIdFromRecent]);

  const [accountId, setAccountId] = useState("");
  const [recent, setRecent] = useState("");
  if (location.state !== null) {
    recordIdFromRecent = location.state;
  }
  const [tableFilteredData, setTableFilteredData] = useState<IVendorConfigurationRepository[]>(
    []
  );
  const filteredData = accountData &&
      accountData.data?.filter(
        (item) =>
          item.autoPayName &&
          item.autoPayName
            .toLowerCase()
            .includes(filterTextState?.trim().toLowerCase())
      );
  useEffect(() => {
    if (accountId?.includes(".")) {
      let accountIds = accountId.split(".");
      const accountIdsArr = accountIds.map((id) => Number(id));
      
  
      setAccountFilteredData(filteredData);
    } else {
      const filteredData = accountData?.data?.filter(
        (x) => x.id === Number(accountId)
      );
      setAccountFilteredData(filteredData);
    }
  }, [accountId, accountData?.data]);

  useEffect(() => {
    if (!recent) setTableFilteredData(filteredData);
  }, [filterTextState]);

  useEffect(() => {
    if (filterText) {
      setAccountList(
        accountData?.data.filter((x) =>
          x.autoPayName
            ?.toLowerCase()
            .includes(filterText?.trim().toLowerCase())
        )
      );
    } else {
      setAccountList(accountData?.data);
    }
  }, [filterText, accountData?.data]);

  const handleDelete = () => {
    const ids = selectedRows.map((row) => row.id);
    setSelectedRows([]);
    setOpenModalDelete(false);
    deactAutopay.mutate(ids);
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
  };

  const {
    mutate: editAutopay,
    isSuccess: editSuccess,
    isError: editError,
    data: editResult,
    reset: resetEditData,
  } = useEditAutopay();

  useEffect(() => {
    setDataIsChanged(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleEdit = (rowData) => {
    setRowToEdit({ ...rowData, isActive: rowData.isActive });
    setActionEditState(true);
    sethideColumn(true);
    setDataIsChanged(false);
    setCheckStatus(rowData.isActive);
    setEditRowId(rowData.id);
  };

  const handleEditFieldsChange = (field, inputvalue) => {
    setDataIsChanged(false);
    inputvalue = inputvalue.trim();
    newData![field] = inputvalue;
    setDataIsChanged(true);

    if (
      newData?.autoPayName.length === 0
    ) {
      setHasAutopay(false);
    } else {
    setHasAutopay(true);
    }
  };

  const handleCheckBox = (e) => {
    const checked = e.target.checked;
    setDataIsChanged(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    newData!.isActive = checked;
    if (newData?.autoPayName.length === 0) {
      setDataIsChanged(false);
    }
  };

  const handleSave = (newData) => {
    if (
      rowToEdit?.autoPayName === newData?.autoPayName &&
      rowToEdit?.isActive === newData?.isActive
    ) {
      setIsSaving(false);
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      queryClient.invalidateQueries("useGetAutopay");
      setOpenModalEdit(false);
    } else {
      editAutopay(newData);
      setEditRowId([]);
      setSelectedRows([]);
      setDataIsChanged(false);
      setOpenModalEdit(false);
      setActionEditState(false);
      setDisabledButton(false);
      setEdit(false);
      sethideColumn(false);
    }
  };

  const handleCancel = () => {
    setActionEditState(false);
    setRowToEdit(undefined);
    setEditRowId([]);
    setDataIsChanged(false);
    setDisabledButton(false);
    setEdit(false);
    sethideColumn(false);
    setHasAutopay(true);
    queryClient.invalidateQueries("useGetAutopay");
  };

  const matColumns = [
    {
      title: "AutoPay Name",
      field: "autoPayName",
      render: (rowData) => {
        return rowData.id === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="AutoPay Name"
              defaultValue={rowData.autoPayName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "autoPayName",
                  inputdata.target.value
                );
              }}
              value={undefined}
            />
          </div>
        ) : (
          <span>{rowData.autoPayName}</span>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.id === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },

    {
      title: "Date Created",
      field: "createdDate",
      hidden: hideColumn,
      align: "center" as
        | "center"
        | "inherit"
        | "justify"
        | "left"
        | "right"
        | undefined,
      render: (rowData) => (
        <div style={{ textAlign: "center" }}>
          {new Date(rowData.createdDate).toLocaleDateString()}
        </div>
      ),
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.id === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.modifiedBy}</>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.id === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData?.modifiedDate
              ? new Date(rowData.modifiedDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return rowData.id === editRowId ? (
          <div className="flex space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer mt-0.5"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e);
              }}
            />
            <label className="items-center cursor-pointer text-green-600 text-xs">
              {checkStatus ? "Uncheck to Deactivate!" : "Check to Activate!"}
            </label>
          </div>
        ) : (
          <div className="mr-4 text-xs">
            {rowData.isActive ? "Active" : "Inactive"}
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center" as
        | "center"
        | "inherit"
        | "justify"
        | "left"
        | "right"
        | undefined,
      render: (rowData) => {
        return rowData.id === editRowId ? (
          <div className="flex items-center place-content-center space-x-2 w-full mr-2">
            <SaveButton
              className={`flex items-center shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
          ${!hasAutopay || !dataIsChanged ? "opacity-50" : "opactiy-100"}`}
              disabled={!hasAutopay || !dataIsChanged}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              onClick={(event) => {
                event.preventDefault();
                handleCancel();
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            {!userPermissions.includes(editPermission) ? (
              ""
            ) : (
              <EditButton
                disabled={disabledButton || selectedRows.length > 0}
                className={
                  disabledButton || selectedRows.length > 0
                    ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                    : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                }
                onClick={() => {
                  setDisabledButton(true);
                  setActionEditState(true);
                  handleEdit(rowData);
                  setNewData(rowData);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];

  const deactAutopay = useMutation(
    (ids: number[] | undefined) => deactivateAutopay(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("useGetAutopay");
        toast.fire(
          "Success",
          "Autopay were deactivated successfully",
          "success"
        );
      },
      onError: (error) => {
        toast.fire(
          "Bulk deactivation of Autopay failed",
          "Server Error: Cannot deactivate Autopay",
          "error"
        );
      },
    }
  );
  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "AutoPay" : "AutoPay"
    }?`}</div>
  );

  // Edit Result
  if (editSuccess && editResult) {
    if (
      (editResult && editResult.status === 400) ||
      editResult.data === "Duplicate"
    ) {
      toast.fire("Failed", "Autopay Already Exists.", "error");
      queryClient.invalidateQueries("useGetAutopay");
      setIsSaving(!isSaving);
    } else if (
      (editResult && editResult.status === 201) ||
      editResult.status === 200
    ) {
      toast.fire("Success", "Autopay Updated Successfully.", "success");
      queryClient.invalidateQueries("useGetAutopay");
      handleCancel();
      setRowToEdit(undefined);
      setActionEditState(false);
    } else if (editResult.status === 500) {
      if (
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        editResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Autopay updated successfully, but " +
            editResult.data.message,
          "warning"
        );
        setIsSaving(false);
        handleCancel();
        setRowToEdit(undefined);
      } else {
        setIsSaving(false);
        setRowToEdit(undefined);
        toast.fire(
          "Failed",
          "Failed to Update Autopay! No Data Saved",
          "error"
        );
      }
      queryClient.invalidateQueries("useGetAutopay");
      setActionEditState(false);
    }
    resetEditData();
  }
  if (editError) {
    setIsSaving(false);
    toast.fire(
      "Server Error",
      "Failed to Update Autopay! No Data Saved",
      "error"
    );
    queryClient.invalidateQueries("useGetAutopay");
    setActionEditState(false);
  }
  const tableOptions = {
    padding: "dense",
    pageSize: 50,
    pageSizeOptions: [50, 100, 200],
    showSelectAllCheckbox: true,
    showTextRowsSelected: false,
    addRowPosition: "first",
    actionsColumnIndex: -1,
  };

  const filterProps = {
    setFilterText: setFilterText,
    setAccountId: setAccountId,
    filterText: filterText,
    accountId: accountId,
    searchTextBox: true,
    autoPaySearch: true,
  };

  return (
    <div className="animate-fade-in-down bg-white p-4">
      <div className="">
        {!actionAddState && (
          <div className="">
            <div className="flex w-full">
              <div className="bg-white w-full">
                <div className="font-bold text-primary text-xl uppercase mx-4">
                  {" "}
                </div>
                <div className="flex justify-between items-center w-full mb-2">
                  <TableFilters
                  defaultText={filterTextState}
                    columnDetails={"AutoPay Name"}
                    textInputName={"autoPayName"}
                    filterText={setFilterTextState}
                    recentText={recent}
                    setRecent={setRecent}
                    disabledButton={false}
                    disabledTextBox={
                      selectedRows !== undefined && selectedRows.length > 0
                    }
                  />
                  {userPermissions.includes(addPermission) ? (
                    <AddButton
                      buttonText="New Autopay"
                      onClick={() => setActionAddState(true)}
                      disabled={
                        actionEditState ||
                        (selectedRows !== undefined && selectedRows.length > 0)
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div>
                  {userPermissions.includes(deletePermission) ? (
                    <div className="text-secondary italic text-xs3 my-2">
                      {!edit ? (
                        <div>
                          <p className="font-bold italic inline-block mr-1">
                            Note:{" "}
                          </p>
                          Tick the box to deactivate some data.
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="">
                  <MaterialTableTS
                    data={
                      isFetching
                      ? []
                      : filterTextState === "" && recent === ""
                      ? accountData?.data
                      : filterTextState === ""
                      ? tableFilteredData
                      : filteredData
                    }
                    showTitle={true}
                    columns={matColumns}
                    isLoading={isFetching}
                    onSelectionChange={handleSelectedRowsChange}
                    selectedRows={selectedRows}
                    selection={
                      !actionEditState &&
                      !actionAddState &&
                      userPermissions.includes(deletePermission)
                    }
                    setConfirmModalOpen={setOpenModalDelete}
                  />
                </div>
              </div>
            </div>
            <ConfirmBoxModal
              ModalTitle="Update Autopay"
              qConfirmation=" Are you sure you want to update this?"
              isOpen={openModalEdit}
              onClose={() => {
                setOpenModalEdit(false);
                setIsSaving(false);
              }}
              onClickFunction={() => {
                handleSave(newData);
                setIsSaving(false);
              }}
              cancelButtonRef={undefined}
            />
            <ConfirmBoxDelete
              ModalTitle="Deactivate Autopay"
              qConfirmation={deleteMessage}
              isOpen={openModalDelete}
              onClose={() => {
                setOpenModalDelete(false);
              }}
              onClickFunction={handleDelete}
              cancelButtonRef={undefined}
            />
          </div>
        )}
        {actionAddState && (
          <div className="">
            <AutopayForm
              isAdd={actionAddState}
              setIsAdd={setActionAddState}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AutopayTable;
